import { render } from "./CardTopRanking.vue?vue&type=template&id=581bd03e&scoped=true"
import script from "./CardTopRanking.vue?vue&type=script&lang=js"
export * from "./CardTopRanking.vue?vue&type=script&lang=js"

import "./CardTopRanking.vue?vue&type=style&index=0&id=581bd03e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581bd03e"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QAvatar});
